import { Component } from '@angular/core';
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { RouterOutlet } from '@angular/router';

@Component({
    templateUrl: './other.component.html',
    imports: [MenuComponent, RouterOutlet]
})
export class OtherComponent {
}
